module.exports = __webpack_public_path__ + "static/media/header1.37cc6e4e.png";